<div class="content-with-filled-button">
    <main class="field col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12 px-0">
        <h2 class="title offset-inline" id="generalTitle">
            {{copyService.copies.max_period_request_title}} {{copyService.copies.max_period_request_title_two}}
        </h2>
        <h3 class="sub-title offset-inline" id="subgeneralTitle">
            {{copyService.copies.max_period_request_subTitle}}
        </h3>
        <div class="content">
            <form class="form row" id="maxPeriodForm" [formGroup]="formGroup">
                <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mt-3">
                    <vcl-form-field class="form" [label]="copyService.copies.max_period_request_label" msgErr="{{ copyService.copies.max_period_error }}">
                        <input vclInput id="inputMaxPeriodValue" type="number"
                        [placeholder]="copyService.copies.max_period_request_place_holder" maxlength="2"
                        (input)="reactiveInputChangeMaxPeriod()" formControlName="maxPeriodValue" [value]="maxPeriod">
                    </vcl-form-field>
                    <span class="info" id="generalSpan">{{ copyService.copies.max_period_request_range }}</span>
                </div>
            </form>
        </div>
    </main>
</div>
<div class="aditional-info">
    <div class="tasa-interes" *ngIf="showRate">
        <strong class="bottom-text" id="textFooter">{{copyService.copies.max_period_request_rate_title}} </strong><br>
        <span class="bottom-text" id="textFooter"> {{copyService.getParametrizedCopy('max_period_request_copy_rate2', [helperService.getRateBySegment(taxRates, SEGMENTS_CONST.PB, 'NMV', RISK_LEVELS.NORISK), helperService.getRateBySegment(taxRates, SEGMENTS_CONST.PB, 'EA', RISK_LEVELS.NORISK)])}}</span>
    </div>
    <div class="remmind">
        <p class="bottom-text" id="textFooter">{{copyService.copies.max_period_request_copy_rate}} </p>
    </div>
    <app-controls class="controls" [hasPrevious]="true" [nextLabel]="copyService.copies.max_period_request_code_button" [nextDisabled]="!formGroup.valid" (next)="next()"></app-controls>
</div>
